{
    "$schema": "./settings.schema.json",
    "GLOBAL_SETTINGS": {
        "frontComponentApi": "https://em-frontend-admin-dev.airtrfx.com",
        "frontComponentProdApi": "https://em-frontend-admin.airtrfx.com",
        "fcServicesApiDev": "https://fc-services-api-dev.everymundo.net",
        "fcServicesApiProd": "https://fc-services-api.airtrfx.com"
    },
    "ENVIRONMENTS": [
        {
            "name": "Localhost",
            "aliases": ["DEV", "dev", "Development", "development"],
            "hostname": "localhost",
            "tenantSyncDomain": "localhost",
            "tenantSyncKey": "em-dev-portal-trfx-tenant",
            "portalHost": "https://portal-dev.everymundo.com",
            "apiUrl": "https://openair-api-dev.everymundo.com",
            "janusUrl": "https://api-dev.everymundo.io",
            "msApiUrl": "https://openair-dev.airtrfx.com",
            "graphQlMiddleware": "http://localhost/graphql",
            "cdLocationsApiUrl": "https://api-dev.everymundo.io/core-dictionary-service/v1",
            "edsThemeGqlUrl": "https://theme-api-dev.everymundo.net/graphql",
            "edsSettingAppUrl": "https://tlquam98ad.execute-api.us-east-1.amazonaws.com/dev",
            "vgSqsUrl": "https://sqs.us-west-1.amazonaws.com/819114787846/theme-service.fifo",
            "airtrfxAiLangflowApi": "https://chat-playground.everymundo.io/api",
            "airtrfxAiLangflowFlowId": "da4a7338-41a0-4e71-8707-53b4aa3c7bab",
            "atcAiApi": "https://api-dev.everymundo.io/ai/chat",
            "axonGenerateWidgetApi": "https://api-dev.everymundo.io/axon-service"
        },
        {
            "name": "Local",
            "aliases": ["DEV", "dev", "Development", "development"],
            "hostname": "openair-local.everymundo.com",
            "tenantSyncDomain": "everymundo.com",
            "tenantSyncKey": "em-dev-portal-trfx-tenant",
            "portalHost": "https://portal-dev.everymundo.com",
            "apiUrl": "https://openair-api-dev.everymundo.com",
            "janusUrl": "https://api-dev.everymundo.io",
            "msApiUrl": "https://openair-dev.airtrfx.com",
            "graphQlMiddleware": "https://openair-middleware-dev.everymundo.com/graphql",
            "cdLocationsApiUrl": "https://api-dev.everymundo.io/core-dictionary-service/v1",
            "edsThemeGqlUrl": "https://theme-api-dev.everymundo.net/graphql",
            "edsSettingAppUrl": "https://tlquam98ad.execute-api.us-east-1.amazonaws.com/dev",
            "vgSqsUrl": "https://sqs.us-west-1.amazonaws.com/819114787846/theme-service.fifo",
            "airtrfxAiLangflowApi": "https://chat-playground.everymundo.io/api",
            "airtrfxAiLangflowFlowId": "da4a7338-41a0-4e71-8707-53b4aa3c7bab",
            "atcAiApi": "https://api-dev.everymundo.io/ai/chat",
            "axonGenerateWidgetApi": "https://api-dev.everymundo.io/axon-service"
        },
        {
            "name": "LocalAirAds",
            "aliases": ["DEV", "dev", "Development", "development"],
            "hostname": "openair-ads-local.everymundo.com",
            "tenantSyncDomain": "everymundo.com",
            "tenantSyncKey": "em-dev-portal-trfx-tenant",
            "portalHost": "https://portal-dev.everymundo.com",
            "apiUrl": "https://openair-api-dev.everymundo.com",
            "janusUrl": "https://api-dev.everymundo.io",
            "msApiUrl": "https://openair-dev.airtrfx.com",
            "graphQlMiddleware": "https://openair-middleware-dev.everymundo.com/graphql",
            "loggerUrl": "https://openair-middleware-dev.everymundo.com/logger",
            "cdLocationsApiUrl": "https://api-dev.everymundo.io/core-dictionary-service/v1",
            "edsThemeGqlUrl": "https://theme-api-dev.everymundo.net/graphql",
            "edsSettingAppUrl": "https://tlquam98ad.execute-api.us-east-1.amazonaws.com/dev",
            "vgSqsUrl": "https://sqs.us-west-1.amazonaws.com/819114787846/theme-service.fifo",
            "airtrfxAiLangflowApi": "https://chat-playground.everymundo.io/api",
            "airtrfxAiLangflowFlowId": "da4a7338-41a0-4e71-8707-53b4aa3c7bab",
            "atcAiApi": "https://api-dev.everymundo.io/ai/chat",
            "axonGenerateWidgetApi": "https://api-dev.everymundo.io/axon-service"
        },
        {
            "name": "LocalDA",
            "aliases": ["DEV", "dev", "Development", "development"],
            "hostname": "openair-da-local.everymundo.com",
            "tenantSyncDomain": "everymundo.com",
            "tenantSyncKey": "em-dev-portal-trfx-tenant",
            "portalHost": "https://portal-dev.everymundo.com",
            "apiUrl": "https://openair-api-dev.everymundo.com",
            "janusUrl": "https://api-dev.everymundo.io",
            "msApiUrl": "https://openair-dev.airtrfx.com",
            "graphQlMiddleware": "https://openair-middleware-dev.everymundo.com/graphql",
            "loggerUrl": "https://openair-middleware-dev.everymundo.com/logger",
            "cdLocationsApiUrl": "https://api-dev.everymundo.io/core-dictionary-service/v1",
            "edsThemeGqlUrl": "https://theme-api-dev.everymundo.net/graphql",
            "edsSettingAppUrl": "https://tlquam98ad.execute-api.us-east-1.amazonaws.com/dev",
            "vgSqsUrl": "https://sqs.us-west-1.amazonaws.com/819114787846/theme-service.fifo",
            "airtrfxAiLangflowApi": "https://chat-playground.everymundo.io/api",
            "airtrfxAiLangflowFlowId": "da4a7338-41a0-4e71-8707-53b4aa3c7bab",
            "atcAiApi": "https://api-dev.everymundo.io/ai/chat",
            "axonGenerateWidgetApi": "https://api-dev.everymundo.io/axon-service"
        },
        {
            "name": "Development",
            "aliases": ["DEV", "dev", "Development", "development"],
            "hostname": "openair-dev.everymundo.com",
            "tenantSyncDomain": "everymundo.com",
            "tenantSyncKey": "em-dev-portal-trfx-tenant",
            "portalHost": "https://portal-dev.everymundo.com",
            "apiUrl": "https://openair-api-dev.everymundo.com",
            "janusUrl": "https://api-dev.everymundo.io",
            "msApiUrl": "https://openair-dev.airtrfx.com",
            "graphQlMiddleware": "https://openair-middleware-dev.everymundo.com/graphql",
            "cdLocationsApiUrl": "https://api-dev.everymundo.io/core-dictionary-service/v1",
            "edsThemeGqlUrl": "https://theme-api-dev.everymundo.net/graphql",
            "edsSettingAppUrl": "https://tlquam98ad.execute-api.us-east-1.amazonaws.com/dev",
            "vgSqsUrl": "https://sqs.us-west-1.amazonaws.com/819114787846/theme-service.fifo",
            "airtrfxAiLangflowApi": "https://chat-playground.everymundo.io/api",
            "airtrfxAiLangflowFlowId": "da4a7338-41a0-4e71-8707-53b4aa3c7bab",
            "atcAiApi": "https://api-dev.everymundo.io/ai/chat",
            "axonGenerateWidgetApi": "https://api-dev.everymundo.io/axon-service"
        },
        {
            "name": "Prepro",
            "aliases": ["PREPRO", "Prepro", "preproduction", "prepro"],
            "hostname": "openair-prepro.everymundo.com",
            "tenantSyncDomain": "everymundo.com",
            "tenantSyncKey": "em-prepro-portal-trfx-tenant",
            "portalHost": "https://portal-prepro.everymundo.com",
            "apiUrl": "https://openair-api-prepro.everymundo.com",
            "janusUrl": "https://api-staging.everymundo.io",
            "msApiUrl": "https://openair-california.airtrfx.com",
            "graphQlMiddleware": "https://openair-middleware-prepro.everymundo.com/graphql",
            "cdLocationsApiUrl": "https://api-staging.everymundo.io/core-dictionary-service/v1",
            "edsThemeGqlUrl": "https://mzxuq6wdi1.execute-api.us-east-1.amazonaws.com/prepro/graphql",
            "edsSettingAppUrl": "https://rrwlq4zp75.execute-api.us-west-1.amazonaws.com/preprod",
            "vgSqsUrl": "https://sqs.us-east-1.amazonaws.com/397307568928/theme-servic-prepro.fifo",
            "airtrfxAiLangflowApi": "https://chat-service-prepro.everymundo.net/api",
            "airtrfxAiLangflowFlowId": "3b8a15a8-683f-4240-9e92-c6aa01300513",
            "atcAiApi": "https://api-staging.everymundo.io/ai/chat",
            "axonGenerateWidgetApi": "https://api-staging.everymundo.io/axon-service"
        },
        {
            "name": "Production",
            "aliases": ["PROD", "production", "prod", "Production"],
            "hostname": "openair.everymundo.com",
            "tenantSyncDomain": "everymundo.com",
            "tenantSyncKey": "em-prod-portal-trfx-tenant",
            "portalHost": "https://portal.everymundo.com",
            "apiUrl": "https://openair-api.everymundo.com",
            "janusUrl": "https://api-internal.everymundo.io",
            "msApiUrl": "https://openair-california.airtrfx.com",
            "graphQlMiddleware": "https://openair-middleware.everymundo.com/graphql",
            "cdLocationsApiUrl": "https://api-internal.everymundo.io/core-dictionary-service/v1",
            "edsThemeGqlUrl": "https://lm35k4k2x5.execute-api.us-west-1.amazonaws.com/prod/graphql",
            "edsSettingAppUrl": "https://j31tg7vwl4.execute-api.us-west-1.amazonaws.com/prod",
            "vgSqsUrl": "https://sqs.us-west-1.amazonaws.com/397307568928/theme-service-prod.fifo",
            "airtrfxAiLangflowApi": "https://chat-service.airtrfx.com/api",
            "airtrfxAiLangflowFlowId": "8eb8922f-70bf-4ce7-9a73-b6ff522f2d5f",
            "atcAiApi": "https://api-internal.everymundo.io/ai/chat",
            "axonGenerateWidgetApi": "https://api-internal.everymundo.io/axon-service"
        }
    ]
}
